import { render, staticRenderFns } from "./ProtocolList.vue?vue&type=template&id=72004d61&"
import script from "./ProtocolList.vue?vue&type=script&lang=js&"
export * from "./ProtocolList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports